import { render, staticRenderFns } from "./compareCategory.vue?vue&type=template&id=65ff3e44&scoped=true"
import script from "./compareCategory.vue?vue&type=script&lang=js"
export * from "./compareCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff3e44",
  null
  
)

export default component.exports